module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-select"
  }, [_c('h1', {
    staticClass: "page-item-title"
  }, [_vm._v("Select 快捷语法糖")]), _vm._v(" "), _c('mt-cell-group', [_c('mt-select', {
    attrs: {
      "label": "单选",
      "options": _vm.singleSelectOptions,
      "select-type": "select"
    },
    on: {
      "selector-click": _vm.singleSelectClick
    },
    model: {
      value: (_vm.singleSelectValue),
      callback: function($$v) {
        _vm.singleSelectValue = $$v
      },
      expression: "singleSelectValue"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.singleSelectValue))])], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-item-title"
  }, [_vm._v("Multi Select 快捷语法糖")]), _vm._v(" "), _c('mt-cell-group', [_c('mt-select', {
    attrs: {
      "label": "多选",
      "options": _vm.multiSelectOptions,
      "select-type": "multi-select",
      "iconpattern": "hook"
    },
    on: {
      "selector-click": _vm.multiSelectClick
    },
    model: {
      value: (_vm.multiSelectValue),
      callback: function($$v) {
        _vm.multiSelectValue = $$v
      },
      expression: "multiSelectValue"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.multiSelectValue))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab8a362","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/select.vue
// module id = 606
// module chunks = 0